/**
 * Menu icon for the mobile nav — the three-line burger.
 *
 * Ported from `Style=Stroke.svg`. The only change is `stroke="currentColor"`
 * instead of the file's hard-coded #111111, so the icon inverts with the bar when
 * it passes over a dark section (see `onDark` in Navbar).
 */
const BurgerIcon = ({ size = 24 }: { size?: number }): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M4 12H20M4 18H20M4 6H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BurgerIcon;
